import { LinkWithArrow } from 'components/basic/LinkWithArrow'
import styles from './TweetsBFCM.module.scss'
import React, { FC, useState } from 'react'
import { Img } from 'components/basic/Img'
import Marquee from 'react-fast-marquee'
import pfps from '../../../twitter_slider_profiles.json'

export interface TweetsBFCMInterface {
	title?: string
}

interface TweetProps {
	text: string
	authorName: string
	authorHandle: string
}

const Tweet: FC<TweetProps> = (props) => {
	return (
		<div className={styles.tweet_container}>
			<div className={styles.tweet_inner_container}>
				<p
					className={styles.tweet_text}
					dangerouslySetInnerHTML={{ __html: `“${props.text}”` }}
				/>
				<div className={styles.tweet_author}>
					<Img
						src={pfps[props.authorHandle] || ''}
						alt={`Twitter profile picture of @${props.authorHandle}`}
						dprHeight={48}
						className={styles.profile_picture}
					/>
					<div className={styles.tweet_credits}>
						<p className={styles.author_name}>{props.authorName}</p>
						<p className={styles.author_handle}>@{props.authorHandle}</p>
					</div>
				</div>
			</div>
		</div>
	)
}

const tweets = [
	<Tweet
		text={'<b>@eightsleep changed everything for me.</b> highly recommend. only downfall is trying to sleep in a bed without, kinda like wanting that large monitor on the plane.'}
		authorName={'Brian Sugar'}
		authorHandle={'briansugar'}
		key="briansugar_tweet"
	/>,
	// <Tweet
	// 	text={"I bought a bed cover from @eightsleep that has cooling/heating and that's been <b>helping me a lot with sleep</b>. Especially with the recent heat waves"}
	// 	authorName={'Cameron Rad'}
	// 	authorHandle={'cameronrad'}
	// 	key="cameronrad_tweet"
	// />,
	// <Tweet
	// 	text={'@eightsleep should be the mattress everyone owns. <b>My time and quality always skyrocket</b> compared to when I don’t have it.'}
	// 	authorName={'Nikhil "Nik" Kundra'}
	// 	authorHandle={'NikKundra'}
	// 	key="NikKundra_tweet"
	// />,
	<Tweet
		text={'I got a water cooled/heated bed cover a while back from @eightsleep and <b>it’s still my most fav thing ever</b>. It’s hot af in LA and my bed is at 55 degrees. Nuts.'}
		authorName={'GINA DARLING'}
		authorHandle={'MissGinaDarling'}
		key="MissGinaDarling_tweet"
	/>,
	<Tweet
		text={'Haven’t used AC once this year despite living in SoCal. Been some rough 80F+ nights, but I think my island Hawaiian genes 😂 and <b>my @eightsleep carried me through it.</b>'}
		authorName={'Chris Kaleiki'}
		authorHandle={'ckaleiki'}
		key="ckaleiki_tweet"
	/>,
	// <Tweet
	// 	text={'+1 on being excited about a mattress. <br/><br/>One year later, <b>I’m still raving about Eight Sleep.</b>'}
	// 	authorName={'Greg Kahn'}
	// 	authorHandle={'GK_Ventures'}
	// 	key="GK_Ventures_tweet"
	// />,
	<Tweet
		text={'Early trainings, <b>afternoon naps and full nights of deep quality sleep during a heatwave</b>... for the first time in my life made possible by @eightsleep! 😴🌡'}
		authorName={'Rachel Neylan'}
		authorHandle={'rachneylan'}
		key="rachneylan_tweet"
	/>,
	<Tweet
		text={'Buying the @eightsleep pod was <b>the best investment</b> I have ever made in sleep quality. 10/10, would recommend.'}
		authorName={'Eric Rea'}
		authorHandle={'ericwilliamrea'}
		key="ericwilliamrea_tweet"
	/>,
	<Tweet
		text={'<b>Most life-changing purchase</b> I’ve made in a long time. It’s insanely addicting'}
		authorName={'Nicolas Cole'}
		authorHandle={'Nicolascole77'}
		key="Nicolascole77_tweet"
	/>,
	<Tweet
		text={
			"My third night with the pod cover <b>I slept through the night for the first time in years. </b>This thing was worth every penny. And for the first time in my life I'm looking forward to going to sleep."
		}
		authorName={'Nicole Corey'}
		authorHandle={'NicoleCoreyRE'}
		key="NicoleCoreyRE_tweet"
	/>,
	<Tweet
		text={'Got an @eightsleep Pod yesterday.<br/><br/>Felt awesome to <b>stay cool the whole night</b> without having to kick the covers off.'}
		authorName={'John Erik Metcalf'}
		authorHandle={'johnerik'}
		key="johnerik_tweet"
	/>,
]

export const TweetsBFCM: FC<TweetsBFCMInterface> = (props) => {
	const [play, setPlay] = useState(true)
	const isMobile = typeof window !== 'undefined' && window.matchMedia('only screen and (max-width: 1023px)').matches && 'ontouchstart' in document.documentElement

	return (
		<div className={styles.container}>
			<h2>{props.title || "Don't just take our word for it"}</h2>

			<div
				className={styles.slider_container}
				id="ig_slider"
				onClick={() => (isMobile ? setPlay((ply) => !ply) : undefined)}
			>
				<Marquee
					speed={40}
					gradient={false}
					play={isMobile ? play : undefined}
					pauseOnHover={isMobile ? undefined : true}
				>
					<div className={styles.tweets_wrapper}>{tweets}</div>
				</Marquee>
			</div>

			<div className={styles.read_more_container}>
				<LinkWithArrow
					href="/wall-of-love"
					id="tweets-slider-more-reviews"
					className={styles.read_more}
				>
					Read more reviews
				</LinkWithArrow>
			</div>
		</div>
	)
}
